import type { DownloadAlunoFotoUseCase } from '@/application/port/in/DownloadAlunoFotoUseCase';
import type { AlunoGateway } from '@/application/port/out/AlunoGateway';

export class DownloadAlunoFoto implements DownloadAlunoFotoUseCase {
  constructor(private readonly gateway: AlunoGateway) {}
  execute(alunoId: string): Promise<Blob | null> {
    return this.gateway.baixarFoto(alunoId);
  }
}
